import * as z from "zod";
export const getFileExchangeSftpSettings = {
  name: "getFileExchangeSftpSettings" as const,
  input: z.object({}),
  output: z.object({
    keys: z.array(z.object({ name: z.string(), fingerprint: z.string() })),
  }),
};
